import { render, staticRenderFns } from "./IconGrow.vue?vue&type=template&id=696afa74"
import script from "./IconGrow.vue?vue&type=script&lang=js"
export * from "./IconGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports